import { Component, OnInit, Input } from '@angular/core';
import { UntypedFormBuilder, UntypedFormControl, UntypedFormGroup, Validators, ReactiveFormsModule } from '@angular/forms';
import { RequestService } from 'src/app/shared/services/htttp/request.service';
import { Constants } from 'src/app/shared/constant/constants';
import { SessionManagerService, LoaderService } from 'src/app/shared/services';
import { Router } from '@angular/router';
import { BsModalService } from 'ngx-bootstrap/modal';
import { Messages } from 'src/app/shared/constant/messages';
import { ToastService } from 'src/app/shared/services';
import { UserAuthService } from '../services/user-auth.service';
import { FirebaseAuthService } from '../services/firebase-auth.service';
import { CustomValidator } from 'src/app/shared/validator/custom.validator';
import { Subject } from 'rxjs';
import { NgIf } from '@angular/common';
import { PRIVACY_POLICY, TERMS_CONDITION } from '@app/shared/constant/routes';

@Component({
  selector: 'app-terms-condition-popup',
  templateUrl: './terms-condition-popup.component.html',
  styleUrls: ['./terms-condition-popup.component.scss'],
  standalone: true,
  imports: [ReactiveFormsModule, NgIf],
})
export class TermsConditionPopupComponent implements OnInit {
  @Input() token!: string;
  @Input() type!: string;
  showParentEmail = false;
  public onClose = new Subject();

  termsForm!: UntypedFormGroup;
  CommonConfig: any = Messages;

  constructor(
    private router: Router,
    private fb: UntypedFormBuilder,
    private requestService: RequestService,
    private loader: LoaderService,
    private sessionManagerService: SessionManagerService,
    private readonly modalService: BsModalService,
    private flashMessage: ToastService,
    private userAuthService: UserAuthService,
    private firebaseAuthService: FirebaseAuthService,
  ) {}

  ngOnInit(): void {
    this.createTermsForm();
  }

  //Terms form validation
  createTermsForm() {
    this.termsForm = this.fb.group({
      isTermsAndCondition: ['', [Validators.requiredTrue]],
      isUserUnderAge: [false],
      parentEmail: new UntypedFormControl(''),
    });
  }

  get f() {
    return this.termsForm.controls;
  }

  //Terms set api call on social login
  terms() {
    this.termsForm.markAllAsTouched();
    if (!this.termsForm.invalid) {
      if (this.type == Constants.SOCIAL_LOGIN_TYPES.GOOGLE_SIGNUP || this.type == Constants.SOCIAL_LOGIN_TYPES.MICROSOFT_SIGNUP) {
        this.onClose.next({ data: this.termsForm.value });
        this.modalService.hide();
      } else {
        this.loader.start();
        this.termsForm.value.parentEmail = this.termsForm.value.isUserUnderAge ? this.termsForm.value.parentEmail : null;
        this.sessionManagerService.createSession(this.token, null, null, null, null, null);
        delete this.termsForm.value.isTermsAndCondition;
        this.requestService
          .patch(Constants.ENDPOINTS.setTerms, { ...this.termsForm.value, priceId: this.sessionManagerService.getPriceId() })
          .subscribe(
            (res: any) => {
              this.loader.stop();
              if (res.data && res.data.activeToken) {
                this.modalService.hide();
                this.sessionManagerService.createSession(
                  res.data.activeToken,
                  res.data.role,
                  res.data.id,
                  res.data.levelId,
                  res.data.levelNo,
                  res.data.email,
                );
                if (res.data.role === Constants.ROLE_IDS.USER) {
                  this.sessionManagerService.setSubscriptionInfo(res.data?.subscriptionInfo);
                  this.sessionManagerService.setPlanInfo(res.data?.planInfo);
                }
                this.sessionManagerService.setLoggedInData(res.data);
                if (this.type == Constants.SOCIAL_LOGIN_TYPES.GOOGLE_SIGNIN || this.type == Constants.SOCIAL_LOGIN_TYPES.MICROSOFT_SIGNIN) {
                  if (res.data.sessionUrl) {
                    window.open(res.data.sessionUrl, '_self');
                  } else {
                    this.userAuthService.navigationBasedOnUser(res.data);
                  }
                } else {
                  if (res.data.role === Constants.ROLE_IDS.USER) {
                    this.firebaseAuthService.loginWithToken(res.data.firebaseToken, res);
                  }
                }
              }
            },
            error => {
              this.loader.stop();
              this.flashMessage.showError(error.error.errorMessage);
            },
          );
      }
    }
  }

  closeModal() {
    this.modalService.hide();
  }

  showTerms(type: string) {
    const routeUrl = type == Constants.STATIC_PAGES.TERMS ? TERMS_CONDITION.URL : PRIVACY_POLICY.URL;
    const url = this.router.serializeUrl(this.router.createUrlTree([routeUrl]));
    window.open(url, '_blank');
  }

  //Validate parent email field if user is underage
  toChange() {
    const email = this.termsForm.get('parentEmail');
    if (this.termsForm.value.isUserUnderAge) {
      this.showParentEmail = true;
      email?.setValidators([Validators.required, Validators.email, CustomValidator.validEmail]);
    } else {
      email?.setValue('');
      email?.markAsUntouched();
      email?.setErrors(null);
      email?.setValidators(null);
      this.showParentEmail = false;
    }
    email?.updateValueAndValidity();
  }
}
